import React from 'react';

/**
 * Opaque cover over the whole tree area while the tree loads. Loading can take a
 * while (the server may lazily migrate the tree's draft storage layout), so
 * instead of a bare canvas with the start-view boundary poking through, the tree
 * area shows only a progress bar until the tree is ready. Used by both the view
 * route ("Opening tree…") and the edit route ("Opening tree for editing…").
 */
export const TreeLoadingOverlay: React.FC<{ message: string }> = ({ message }) => (
    <div className="tree-loading-overlay" role="status">
        <p className="tree-loading-overlay-text">{message}</p>
        <div className="tree-loading-overlay-bar" role="progressbar" aria-label={message}>
            <div className="tree-loading-overlay-bar-fill" />
        </div>
    </div>
);
